module.exports = __webpack_public_path__ + "img/titanhq-logo-green.80034b9d.svg";